import {
  ENewbuildingBrokerOfferBookingActions,
  TNewbuildingBrokerOfferBookingActions,
} from 'shared/actions/newbuildingBrokerOfferBooking';
import { INewbuildingBrokerOfferBooking } from 'shared/types/newbuildingBrokerOfferBooking';

const initialState: INewbuildingBrokerOfferBooking = {
  enabled: false,
  callbackWidgetOpened: false,
};

export const newbuildingBrokerOfferBookingReducer = (
  state: INewbuildingBrokerOfferBooking = initialState,
  action: TNewbuildingBrokerOfferBookingActions,
): INewbuildingBrokerOfferBooking => {
  switch (action.type) {
    case ENewbuildingBrokerOfferBookingActions.SetEnabled:
      return {
        ...state,
        enabled: action.payload,
      };

    case ENewbuildingBrokerOfferBookingActions.SetCallbackWidgetOpened:
      return {
        ...state,
        callbackWidgetOpened: action.payload,
      };

    default:
      return state;
  }
};
